import React from 'react';
import { Popup } from 'devextreme-react/popup';
import TextBox from 'devextreme-react/text-box';
import Validator, { CustomRule, ValidationRule } from 'devextreme-react/validator';
import { Button } from 'devextreme-react/button';
import { ValidationGroup } from 'devextreme-react/validation-group';

import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

import validFilename from 'valid-filename';

import './PopupExportProduct.scss'

// props
//      gridInstance: instance of grid to export
//
//      onInitialized: callback
//
//      setUserSettings: callable


function createNewFileName() {
    let d = new Date();
    return 'Product_' + d.getDate().toString().padStart(2, '0') + '_' + (d.getMonth() + 1).toString().padStart(2, '0') + '_' + d.getFullYear() + '.xlsx';
}


class PopupExportProduct extends React.Component {
    constructor(props) {
        super(props);

        this.popupInstance = null;

        this.textBoxNameInstance = null;

        this.buttonSave_OnClick = this.buttonSave_OnClick.bind(this);

        this.validationGroupInstance = null;

        this.fileName = 'Product';

        this.userSettings = {
            UserId: parseInt(sessionStorage.getItem("currentUserId"), 10),
            DefaultViewId: -1,
            DefaultFilterId: -1,
            ExportColors: true,
            UseBlanksForZeroes: true,
            UseColorsProducts: true,
            ColorOriginProducts: 'SHOP',
            ShowSelectedCell: true,
            UseAdvancedFiltering: false,
        }
    }

    // CALLBACKS
    onInitialized = (instance) => {
        if (this.props.onInitialized) {
            this.props.onInitialized(instance);  // callback
        }
    }

    // CALLABLES
    setUserSettings = (settings) => {
        this.userSettings = settings;
    }


    // POPUP
    popup_OnInitialized = (e) => {
        this.popupInstance = e.component;
        this.onInitialized(e.component);  // callback
    }

    popup_OnShowing = (e) => {
        this.fileName = createNewFileName();
    }

    popup_OnShown = (e) => {
        this.textBoxNameInstance.option('value', this.fileName);

        document.getElementById('textBoxFileNameInput').select();

        this.textBoxNameInstance.focus();
    }

    // TEXTBOX
    textBoxAttributes = {
        id: 'textBoxFileNameInput',
    }

    textBoxName_OnInitialized = (e) => {
        this.textBoxNameInstance = e.component;
    }

    validationGroup_OnInitialized = (e) => {
        this.validationGroupInstance = e.component;
    }


    // BUTTON
    buttonSave_OnClick = (e) => {
        this.validationGroupInstance.validate();

        if (this.textBoxNameInstance.option('isValid') === true) {
            this.exportToExcel(this.textBoxNameInstance.option('value').trim().replace(/.xlsx$/gi, '') + '.xlsx');
            this.popupInstance.hide();
        } else {
            this.textBoxNameInstance.focus();
        }
    }



    validateFileName = () => {
        let isValid = false;

        if (validFilename(this.fileName)) {
            isValid = true;
        }

        return isValid;
    }

    exportToExcel = (name) => {
        const fileName = name;
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');

        if (this.userSettings.ExportColors) {
            exportDataGrid({
                component: this.props.gridInstance,
                worksheet: worksheet,
                customizeCell: this.customizeExcelCell
            }).then(function () {
                workbook.xlsx.writeBuffer()
                    .then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
                    });
            });
        } else {
            exportDataGrid({
                component: this.props.gridInstance,
                worksheet: worksheet
            }).then(function () {
                workbook.xlsx.writeBuffer()
                    .then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
                    });
            });
        }
    }

    // set excel cell layout
    customizeExcelCell = (options) => {
        const { gridCell, excelCell } = options;

        if (gridCell.rowType === 'data') {
            if (gridCell.column.dataField === 'Shops' || gridCell.column.dataField === 'ProductName' || gridCell.column.dataField === 'ProductTypeName') {
                let bg = (gridCell.data.ColorHex !== null ? gridCell.data.ColorHex.replace('#', '').slice(0, 6) : 'FFFFFF');
                let fg = (gridCell.data.ForeColorHex !== null ? gridCell.data.ForeColorHex.replace('#', '').slice(0, 6) : '000000');
                excelCell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bg }
                };
                excelCell.font = {
                    color: { argb: fg }
                }
            }
        } else if (gridCell.rowType === 'header') {
            // ownerband means: has band
            if (gridCell.column.ownerBand) {

            //    if (isNaN(gridCell.column.dataField) === false && this.state.dataSourceSubArtistColors.length > 0) {
            //        let bg = 'FFFFFF';
            //        let fg = '000000';

            //        let index = this.state.dataSourceSubArtistColors.findIndex(subArtistId => subArtistId.SubArtistId === parseInt(gridCell.column.dataField, 10));
            //        if (index > -1) {
            //            bg = this.state.dataSourceSubArtistColors[index].ColorHex.replace('#', '');
            //            fg = this.state.dataSourceSubArtistColors[index].ForeColorHex.replace('#', '');
            //        }

            //        excelCell.fill = {
            //            type: 'pattern',
            //            pattern: 'solid',
            //            fgColor: { argb: bg }
            //        };
            //        excelCell.font = {
            //            color: { argb: fg }
            //        }
            //    }
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <Popup
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    title='Save as ...'
                    width={300}
                    height={155}
                    showCloseButton={true}
                    onInitialized={this.popup_OnInitialized}
                    onShowing={this.popup_OnShowing}
                    onShown={this.popup_OnShown}
                >
                    <ValidationGroup onInitialized={this.validationGroup_OnInitialized}>
                        <div>
                            <div>
                                <div>
                                    <TextBox
                                        onInitialized={this.textBoxName_OnInitialized}
                                        defaultValue=''
                                        inputAttr={this.textBoxAttributes}
                                        hint='Enter name ...'
                                    >
                                        <Validator>
                                            <ValidationRule type="required" message="Required" />
                                            <CustomRule validationCallback={this.validateFileName} message="Invalid file name" />
                                        </Validator>
                                    </TextBox>
                                </div>
                            </div>

                            <div className='pep-button'>
                                <Button
                                    width={120}
                                    text="Export"
                                    className='dx-button'
                                    onClick={this.buttonSave_OnClick}
                                />
                            </div>

                        </div>
                    </ValidationGroup>


                </Popup>
            </React.Fragment>
        );
    }

}

export default PopupExportProduct

